import React from 'react';
import PropTypes from 'prop-types';
import { InputMi } from '@design-system-etat/dsfr-react';
import InputFiles from '../../../../../components/Commun/Form/InputFiles';
import BoutonTelechargementFichier from '../../../../../components/BoutonTelechargementFichier/BoutonTelechargementFichier';

const InputsLicencie = ({
    selectLicencieOrAncienLicencie,
    licenceExist,
    isAncienLicencie,
    numeroLicence,
    labelInputMi,
    licenceFichierName,
    register,
    licence,
    fileUploaded,
}) => {
    let inputs;

    if (selectLicencieOrAncienLicencie === 'isLicencie') {
        if ((licenceExist && isAncienLicencie) || !licenceExist) {
            inputs = (
                <>
                    <InputMi
                        name={numeroLicence}
                        label={labelInputMi}
                        {...register(numeroLicence)}
                        required
                    />

                    {licenceFichierName && (
                        <InputFiles
                            name={licenceFichierName}
                            label="Importer la licence"
                            required
                            licenceFichier={fileUploaded ? [fileUploaded] : []}
                        />
                    )}
                </>
            );
        } else if (licenceExist && !isAncienLicencie) {
            inputs = (
                <>
                    <InputMi
                        name={numeroLicence}
                        label={labelInputMi}
                        disabled
                        value={licence.numero}
                    />

                    {licenceFichierName && licence?.licenceFichier?.filename && (
                        <BoutonTelechargementFichier
                            libelle={licence?.licenceFichier.filename}
                            uuidFichier={licence?.licenceFichier.uuid}
                            id={`fichier_${licence?.licenceFichier.filename}`}
                        />
                    )}
                </>
            );
        }
    } else if (selectLicencieOrAncienLicencie === 'isAncienLicencie') {
        if ((licenceExist && !isAncienLicencie) || !licenceExist) {
            inputs = (
                <>
                    <InputMi
                        name={numeroLicence}
                        label={labelInputMi}
                        {...register(numeroLicence)}
                    />

                    {licenceFichierName && (
                        <InputFiles
                            name={licenceFichierName}
                            label="Importer la licence"
                            licenceFichier={fileUploaded ? [fileUploaded] : []}
                        />
                    )}
                </>
            );
        } else if (licenceExist && isAncienLicencie) {
            inputs = (
                <>
                    {licence.numero && (
                        <InputMi
                            name={numeroLicence}
                            label={labelInputMi}
                            value={licence.numero}
                            disabled
                        />
                    )}

                    {licenceFichierName && licence?.licenceFichier?.filename && (
                        <BoutonTelechargementFichier
                            libelle={licence?.licenceFichier?.filename}
                            uuidFichier={licence?.licenceFichier.uuid}
                            id={`fichier_${licence?.licenceFichier?.filename}`}
                        />
                    )}
                </>
            );
        }
    }

    return inputs;
};

InputsLicencie.propTypes = {
    selectLicencieOrAncienLicencie: PropTypes.string,
    licenceExist: PropTypes.bool,
    isAncienLicencie: PropTypes.bool,
    numeroLicence: PropTypes.string,
    labelInputMi: PropTypes.string,
    licenceFichierName: PropTypes.string,
    register: PropTypes.func,
    licence: PropTypes.object,
};

export default InputsLicencie;
